import { DashBoardCards } from "../../../components/dashboard/DashBoardCards";
import { DashboardContainer } from "../../../components/dashboard/DashboardContainer";

const Dashboard = () => (
  <DashboardContainer>
    <DashBoardCards />
  </DashboardContainer>
);

export default Dashboard;
